export default "__VITE_ASSET__JomCCFlX__"